import {useLocation, useOutletContext} from "react-router-dom";

import {PERMIT_TYPES} from "permit/data";
import {useDownload} from "base/file/utilities";
import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider";
import {usePermitApplicationForm} from "permitapplication/hooks";
import {PermitApplicationService} from "permitapplication/service";

import {PermitApplicationPaymentFormFields, PermitForm} from "./form";
import {FormContainer, FormDatePickerCombo} from "base/form/components";
import {DownloadPDFButton} from "base/pdf/presentational";
import {DividerWithHeading} from "base/ui/headings/components";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import TransportFormDatePickerCombo from "./form/TransportFormDatePickerCombo";

const PermitApplicationPaymentStep = () => {
    const download = useDownload();
    const navigate = useNavigateWithReload();

    const {handleErrors} = useErrors();
    const {permit, isStepEditable} = useOutletContext();

    const basePath = useLocation();
    const fileFields = ["payment_receipt"];

    const {handleFormSubmit} = usePermitApplicationForm(permit, basePath, fileFields);

    const handleDownload = () => {
        if (permit) {
            return PermitApplicationService.downloadPermit(permit.id).then(response => {
                return download(response)
                    .then(() => navigate("", true))
                    .catch(error => handleErrors(error));
            });
        } else {
            return Promise.reject("Nenhuma autorização foi selecionada.");
        }
    };

    const displayedTypes = PERMIT_TYPES.filter(type =>
        permit?.types_label?.includes(type.label)
    );

    const allowPrintingPermit = displayedTypes.every(
        type =>
            !!(permit[`${type.value}_start_date`] && permit[`${type.value}_end_date`])
    );

    return permit ? (
        <Stack spacing={3}>
            <PermitForm permit={permit} onSubmit={handleFormSubmit}>
                <Stack spacing={2}>
                    <FormContainer label="Comprovativo de pagamento">
                        <PermitApplicationPaymentFormFields
                            disabled={!isStepEditable}
                        />
                    </FormContainer>
                    <FormContainer>
                        <Grid container columnSpacing={6} rowSpacing={2}>
                            {displayedTypes.map(type => (
                                <Grid item xs={12} md={6} key={type.label}>
                                    <DividerWithHeading
                                        label={`Validade da guia de ${type.label}`}
                                    />
                                    <Stack direction="row" spacing={1}>
                                        {type.value === "transport" ? (
                                            <TransportFormDatePickerCombo
                                                startDateLabel="Data de início"
                                                startDateName={`${type.value}_start_date`}
                                                endDateLabel="Data de caducidade"
                                                endDateName={`${type.value}_end_date`}
                                                disabled={!isStepEditable}
                                                required
                                            />
                                        ) : (
                                            <FormDatePickerCombo
                                                startDateLabel="Data de início"
                                                startDateName={`${type.value}_start_date`}
                                                endDateLabel="Data de caducidade"
                                                endDateName={`${type.value}_end_date`}
                                                disabled={!isStepEditable}
                                                required
                                            />
                                        )}
                                    </Stack>
                                </Grid>
                            ))}
                        </Grid>
                    </FormContainer>
                </Stack>
            </PermitForm>
            <Stack alignItems="center" pb={2}>
                <DownloadPDFButton
                    handleGeneratePDF={handleDownload}
                    text="Imprimir autorização"
                    color="secondary"
                    disabled={!allowPrintingPermit}
                />
            </Stack>
        </Stack>
    ) : null;
};

export default PermitApplicationPaymentStep;
